import { create } from 'zustand';

export interface ToastMessage {
  id: string;
  variant: 'success' | 'error' | 'info' | 'warning';
  title: string;
  description?: string;
}

// Transient toast queue. Distinct from the persisted `notifications`
// domain (bell icon, backed by React Query + the /notifications API) —
// toasts are fire-and-forget UI feedback for the current session only.
interface NotificationUiState {
  toasts: ToastMessage[];
  pushToast: (toast: Omit<ToastMessage, 'id'>) => void;
  dismissToast: (id: string) => void;
}

export const useToastStore = create<NotificationUiState>((set) => ({
  toasts: [],
  pushToast: (toast) =>
    set((s) => ({ toasts: [...s.toasts, { ...toast, id: crypto.randomUUID() }] })),
  dismissToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
